import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import { useCustomReportStructure } from './useCustomReportStructure'

export const useCtxCustomReportStructure = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useCustomReportStructure(companyId)
}
